import src from "IMAGE";
export default { src, width: 4051, height: 514, blurWidth: 8, blurHeight: 1, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAYAAADjAO9DAAAALElEQVR42gEhAN7/AMXFxTm5ublEt7e3R8PDwzq4uLhGvb29Qbi4uEbExMQ6S+4Twer03tcAAAAASUVORK5CYII="};
